import { create } from 'zustand';

export type NetworkStatus = 'online' | 'offline' | 'server-down' | 'reconnected';

interface NetworkState {
  status: NetworkStatus;
  retryCount: number;
  lastErrorAt: number | null;
  /** Экран сам говорит о сети на месте (строка тренировки «ответ не отправлен», B13): общая плашка
   *  не показывается ни в каком статусе — два сообщения об одном не нужны, а плашка закрывает шапку. */
  bannerSuppressed: boolean;
  setBannerSuppressed: (suppressed: boolean) => void;
  setStatus: (status: NetworkStatus) => void;
  markServerError: () => void;
  markServerOk: () => void;
  markBrowserOffline: () => void;
  markBrowserOnline: () => void;
  bumpRetry: () => void;
}

export const useNetworkStore = create<NetworkState>((set, get) => ({
  status: 'online',
  retryCount: 0,
  lastErrorAt: null,
  bannerSuppressed: false,
  setBannerSuppressed: (bannerSuppressed) => set({ bannerSuppressed }),
  setStatus: (status) => set({ status }),
  markServerError: () => {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      set({ status: 'offline', lastErrorAt: Date.now() });
      return;
    }
    set({ status: 'server-down', lastErrorAt: Date.now() });
  },
  markServerOk: () => {
    const { status } = get();
    if (status === 'online') return;
    set({ status: 'reconnected', retryCount: 0 });
  },
  markBrowserOffline: () => set({ status: 'offline', lastErrorAt: Date.now() }),
  markBrowserOnline: () => {
    const { status } = get();
    if (status === 'offline') {
      set({ status: 'reconnected' });
    }
  },
  bumpRetry: () => set((state) => ({ retryCount: state.retryCount + 1 })),
}));

export const networkBus = {
  serverError: () => useNetworkStore.getState().markServerError(),
  serverOk: () => useNetworkStore.getState().markServerOk(),
};
